import React from 'react'

interface ChatScrollToBottomIconProps {
  size?: number
  className?: string
}

export const ChatScrollToBottomIcon: React.FC<ChatScrollToBottomIconProps> = ({
  size = 32,
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        width="32"
        height="32"
        rx="16"
        fill="black"
        fillOpacity="0.2"
        style={{ backdropFilter: 'blur(24px)' }}
      />
      <path
        d="M22.3994 21C22.7308 21 23 21.2682 23 21.5996C23 21.931 22.7308 22.1992 22.3994 22.1992H9.59961C9.26824 22.1992 9 21.931 9 21.5996C9 21.2682 9.26824 21 9.59961 21H22.3994ZM16 9C16.3314 9 16.5996 9.26921 16.5996 9.60059V17.7002L19.5654 14.5859C19.794 14.3462 20.1742 14.337 20.4141 14.5654C20.654 14.794 20.6631 15.1741 20.4346 15.4141L16.4346 19.6143C16.3213 19.7331 16.1642 19.7998 16 19.7998C15.8358 19.7998 15.6787 19.7331 15.5654 19.6143L11.5654 15.4141C11.3369 15.1741 11.346 14.794 11.5859 14.5654C11.8258 14.337 12.206 14.3462 12.4346 14.5859L15.4004 17.7002V9.60059C15.4004 9.26922 15.6686 9 16 9Z"
        fill="white"
      />
    </svg>
  )
}
